<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <span>管理员： {{ username }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item>
          <span @click="openPassword" style="display:block;">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :title="editDia.title"
      :visible.sync="editDia.visible"
      class="text_c"
      @close="editDiaClose"
      width="50%"
    >
      <el-form
        :inline="false"
        :model="editInfo"
        :rules="editInfoRules"
        ref="editInfoForm"
        class="text_l"
        size="small"
        label-width="100px"
      >
        <el-form-item label="新密码：" prop="newPassword">
          <el-input
            v-model="editInfo.newPassword"
            placeholder="请输入新密码"
            clearable
            style="width: 315px"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认密码：" prop="password">
          <el-input
            v-model="editInfo.password"
            placeholder="请确认密码"
            clearable
            style="width: 315px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDiaClose">取 消</el-button>
        <el-button @click="changePassword" type="primary">确认修改</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { clearCookie, getCookie } from "@/utils/support";
import { resetRouter } from "@/router/resetRouter.js";
import store from "@/store";
export default {
  data() {
    const checkPassword = (rule, value, callback) => {
      if (value !== this.editInfo.newPassword) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      username: null,
      fullscreenLoading: false,
      editDia: {
        title: null,
        visible: false
      },
      editInfo: {},
      editInfoRules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { message: "密码不能小于6位", trigger: "blur", min: 6 }
        ],
        password: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { message: "密码不能小于6位", trigger: "blur", min: 6 },
          { trigger: "blur", validator: checkPassword }
        ]
      }
    };
  },
  created() {
    this.getUserName();
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  methods: {
    getUserName() {
      this.username = getCookie("adminName");
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      store.dispatch("FedLogOut").then(() => {
        clearCookie();
        resetRouter();

        this.$notify.success({
          title: "退出登录成功",
          message: "您已退出登录"
        });
        this.$router.push({ path: "/login" });
      });
    },
    updateCache() {
      this.fullscreenLoading = true;
      this.$http.get("/profile/cache").then(res => {
        if (res.code === 200) {
          this.fullscreenLoading = false;
          this.$notify.success({
            title: "缓存已更新",
            message: res.msg,
            duration: 1000
          });
        } else {
          this.$message.error(res.msg);
          this.fullscreenLoading = false;
        }
      });
    },
    editDiaClose() {
      this.editDia = {
        title: null,
        visible: false
      };
      this.editInfo = {};
    },
    openPassword() {
      this.editDia = {
        title: "修改密码",
        visible: true
      };
    },
    changePassword() {
      this.$refs["editInfoForm"].validate(valid => {
        if (valid) {
          this.$http
            .post("/user/savePassword", { password: this.editInfo.password })
            .then(res => {
              if (res.code === 200) {
                this.$notify.success({
                  title: "修改密码成功，请重新登录",
                  message: res.msg,
                  duration: 1000
                });
                this.editDiaClose();
                sessionStorage.clear();
                clearCookie();
                this.$router.push({ path: "/login" });
              } else {
                this.$message.error(res.msg);
              }
            });
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  background-color: #001529;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
    color: #ffffff !important;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      color: #ffffff;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue